import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1C2A24] text-[#E5E1D8] pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#F4F1EA] text-[#2C4C3B] font-heading text-xl">
                C
              </span>
              <div className="leading-tight">
                <p className="font-heading text-2xl text-white">
                  Carlene&rsquo;s Comfort Care
                </p>
                <p className="text-[11px] tracking-[0.25em] uppercase text-[#667B68] mt-1">
                  Class 3 Adult Foster Home
                </p>
              </div>
            </div>
            <p className="mt-6 text-[15px] leading-relaxed text-[#A8B3AB] max-w-md">
              A quiet, family-run home in Scio, Oregon — where Alzheimer&rsquo;s,
              dementia, and hospice care are met with dignity and patience.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#F4F1EA]/60">
              Visit
            </p>
            <a
              href="https://www.google.com/maps?q=38885+Stayton+Scio+Rd,+Scio,+OR+97374"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address"
              className="mt-3 inline-flex items-start gap-2 text-white hover:text-[#F4F1EA] transition-colors"
            >
              <MapPin className="w-4 h-4 mt-1 shrink-0" />
              <span>
                38885 Stayton Scio Rd
                <br />
                Scio, OR 97374
              </span>
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#F4F1EA]/60">
              Get in touch
            </p>
            <div className="mt-3 space-y-3">
              <a
                href="tel:+15033942321"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-white hover:text-[#F4F1EA] transition-colors"
              >
                <Phone className="w-4 h-4" />
                (503) 394-2321
              </a>
              <a
                href="mailto:karie_richard@yahoo.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-white hover:text-[#F4F1EA] transition-colors"
              >
                <Mail className="w-4 h-4" />
                karie_richard@yahoo.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#A8B3AB]">
          <p>
            &copy; {new Date().getFullYear()} Carlene&rsquo;s Comfort Care.
            Owned &amp; operated by Karie Andrews.
          </p>
          <p className="tracking-[0.2em] uppercase">
            Dignity &middot; Comfort &middot; Home
          </p>
        </div>
      </div>
    </footer>
  );
}
